import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import StArrowRightSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/st-arrow-right.svg';
import { slugify } from '@utils/studioUtils';
import { FaqPageSectionStyles } from './FaqPageSection.styled';
import { getCategorySlug } from '@utils/faqUtils';
import colors from 'pubweb-smokey/dist/colors';

const FaqPageSection = ({ category }) => {
  const colorStringArray = category?.sectionBackgroundColor.split(' ') || [];
  const sectionBgColor =
    colorStringArray.length > 0
      ? colorStringArray[colorStringArray.length - 1]
      : colors.accent.veryLightBlue;
  return (
    <FaqPageSectionStyles $styleProps={{ bgColor: sectionBgColor }}>
      <div className="constrained-width">
        <div className="section-left">
          <h2 className="section-header">{category?.sectionHeader}</h2>
          <div className="section-intro">
            <p>{category?.sectionIntro}</p>
          </div>
        </div>

        <div className="section-right">
          <ul className="faq-questions">
            {category.faqs?.map((faq, j) => {
              return (
                <li
                  key={`faq-${slugify(category?.sectionHeader)}-${j + 1}`}
                  className="faq-question-link"
                >
                  <Link
                    href={`/faq${getCategorySlug(faq?.faqCategory)}${
                      faq?.slug
                    }`}
                  >
                    <div className="faq-question-text">{faq?.faqQuestion}</div>{' '}
                    <div>
                      <div>
                        <StArrowRightSvg />
                      </div>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </FaqPageSectionStyles>
  );
};

export default FaqPageSection;

FaqPageSection.propTypes = {
  category: PropTypes.shape({
    categoryPageLink: PropTypes.shape({
      link: PropTypes.string,
    }),
    faqs: PropTypes.arrayOf(
      PropTypes.shape({
        faqQuestion: PropTypes.string,
        slug: PropTypes.string,
      })
    ),
    sectionHeader: PropTypes.string,
    sectionIntro: PropTypes.string,
    sectionBackgroundColor: PropTypes.string,
  }),
};
